<div class="content blog">
  <theme-body-top/>
  <div class="content-layout">
    <div class="content-body">
      <h1>${$global.title}</h1>
      <if=$global.description>
        <p class="description">${$global.description}</p>
      </if>
      <if=$global.date>
        <p class="meta">Published: ${$global.date}</p>
      </if>
      <if=$global.author>
        <p class="meta">By ${$global.author}</p>
      </if>
      <if=$global.tags>
        <p class="meta">
          <for|tag| of=$global.tags>
            <span class="tag">${tag}</span>
          </for>
        </p>
      </if>
      <hr>
      <${$global.contentComponent || {}}>
        <div>No content</div>
      </${$global.contentComponent || {}}>
    </div>
    <if=$global.toc>
      <toc headers=$global.toc/>
    </if>
  </div>
  <theme-body-bottom/>
</div>

<style>
  .content-layout {
    display: flex;
    gap: 32px;
    max-width: 1100px;
    margin: 0 auto;
    position: relative;
  }

  .content-body {
    flex: 1;
    min-width: 0;
    max-width: 100%;
  }

  .toc {
    position: sticky;
    top: 1rem;
    width: 200px;
    flex-shrink: 0;
  }

  .meta {
    font-size: 0.875rem;
    color: #666;
  }

  .tag {
    display: inline-block;
    background: #e5e7eb;
    padding: 0.125rem 0.5rem;
    border-radius: 4px;
    margin-right: 0.5rem;
    font-size: 0.75rem;
  }
</style>
